import React from 'react'
import PropTypes from 'prop-types'
import { Switch } from 'react-router-dom'
import { centrePropType } from '../../../types/contentful-v1'
import Route from '../../components/boundary-route'
import TEMPLATES from '../../templates'
import {
  BROWSE_STORES,
  OPENING_HOURS,
  STORE,
  WHATS_HAPPENING,
  CENTRE_MAP,
  EVENT,
  NEWS,
  OFFER,
  SERVICE,
  STORY,
  MOVIES,
  MOVIE_DETAILS,
  TEMPLATE,
  CENTRE,
  PARKING,
} from '../../paths'
import { BasicPageContext } from '../../context'
import Parking from './parking'
import Template from './template'
import Home from './home'
import BrowseStores from './browse-stores-category'
import OpeningHours from './opening-hours'
import WhatsHappening from './whats-happening/'
import StoreDetail from './store'
import CentreMap from './centre-map'
import {
  EventDetail,
  NewsDetail,
  OfferDetail,
  StoryDetail,
} from './entry-detail'
import { ServiceDetail } from './service'
import CinemaDetail from './movies'
import MovieDetail from './movies/movie-detail'

const CentreRoutes = ({ firstPage, centre }) => (
  <BasicPageContext.Consumer>
    {isBasicPage => {
      const maybeAddBasicPrefix = path =>
        `${isBasicPage ? '/_basic' : ''}${path}`
      return (
        <Switch>
          <Route
            path={maybeAddBasicPrefix(BROWSE_STORES)}
            render={props => (
              <BrowseStores
                {...props}
                centre={centre}
                pathPrefix={maybeAddBasicPrefix(BROWSE_STORES)}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(OPENING_HOURS)}
            render={() => (
              <OpeningHours
                centre={centre}
                templatePath={TEMPLATES['opening-hours']}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(STORE)}
            render={({ match }) => (
              <StoreDetail
                match={match}
                centre={centre}
                templatePath={TEMPLATES.store}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(WHATS_HAPPENING)}
            render={() => (
              <WhatsHappening
                centre={centre}
                templatePath={TEMPLATES['whats-happening']}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(EVENT)}
            render={({ match }) => (
              <EventDetail
                id={match.params.id}
                centre={centre}
                slug={match.params.slug}
                templatePath={TEMPLATES.event}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(NEWS)}
            render={({ match }) => (
              <NewsDetail
                id={match.params.id}
                centre={centre}
                slug={match.params.slug}
                templatePath={TEMPLATES.news}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(OFFER)}
            render={({ match }) => (
              <OfferDetail
                id={match.params.id}
                centre={centre}
                slug={match.params.slug}
                templatePath={TEMPLATES.offer}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(STORY)}
            render={({ match }) => (
              <StoryDetail
                id={match.params.id}
                centre={centre}
                slug={match.params.slug}
                templatePath={TEMPLATES.story}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(SERVICE)}
            render={({ match }) => (
              <ServiceDetail
                id={match.params.id}
                centre={centre}
                slug={match.params.slug}
                templatePath={TEMPLATES.service}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(MOVIES)}
            render={({ match }) => (
              <CinemaDetail
                centre={centre}
                match={match}
                templatePath={TEMPLATES.movie}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(MOVIE_DETAILS)}
            render={({ match }) => (
              <MovieDetail
                id={match.params.id}
                slug={match.params.slug}
                date={match.params.date}
                centre={centre}
                match={match}
                templatePath={TEMPLATES.movie}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(CENTRE_MAP)}
            render={props => <CentreMap centre={centre} {...props} />}
          />
          <Route
            path={maybeAddBasicPrefix(PARKING)}
            render={() => (
              <Parking centre={centre} templatePath={TEMPLATES.service} />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(TEMPLATE)}
            render={({ match }) => (
              <Template
                templatePath={match.params.templatePath}
                centre={centre}
              />
            )}
          />
          <Route
            path={maybeAddBasicPrefix(`/:${CENTRE}`)}
            render={() => (
              <Home
                templatePath={TEMPLATES.centre}
                centre={centre}
                animate={firstPage}
              />
            )}
          />
        </Switch>
      )
    }}
  </BasicPageContext.Consumer>
)

CentreRoutes.propTypes = {
  firstPage: PropTypes.bool,
  centre: centrePropType,
}

export default CentreRoutes
